import { styled } from 'styled-components';

/**
 * Can be used for similar components as DragHandle to keep the same styling
 */
export const DragHandleBase = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  width: 1.5rem;
`;
